import React, { useState } from "react";
import { Button, Col, Dropdown, Menu, Row, Table, Tag, Tooltip } from "antd";

import { FormatNumber } from "../../ValueObjects";
import ModalDetalheRetencaoNfi from '../modals/modalDetalhesRetencaoNfi';
import { MoreOutlined, ProfileOutlined } from "@ant-design/icons";

export default function TabDetalheServico({ itensNF }) {

    const [exibirModalRetencao, setExibirModalRetencao] = useState(false);
    const [dadosItem, setDadosItem] = useState([]);

    function menuTable(record) {
        const itemRetencao = record.itemRetencao && record.itemRetencao.length > 0;
        const tooltip = itemRetencao ? '' : 'Retenção do Produto não disponível';

        const items = [
            {
                key: '1',
                label: (
                    <Tooltip title={tooltip}>
                        <Button icon={<ProfileOutlined />} type='text'
                            onClick={() => { { setExibirModalRetencao(true); setDadosItem(record) } }}
                            disabled={!itemRetencao}
                        >Retenções</Button>
                    </Tooltip>
                )
            }
        ]
        return { items };
    }

    return (
        <div className="tabela">
            <Table columns={
                [
                    {
                        width: '4%',
                        align: 'center',
                        fixed: 'left',
                        render: ({ pro_codigo }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <Tag color="processing" className="w-75">
                                            <b>{pro_codigo}</b>
                                        </Tag>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: '',
                        fixed: 'left',
                        width: '20%',
                        render: ({ pro_descricao }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        <b>{(pro_descricao)}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'N°',
                        width: '1.5%',
                        align: 'center',
                        fixed: 'left',
                        render: ({ nfi_numeroitem }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{(nfi_numeroitem)}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'CFOP',
                        width: '2%',
                        align: 'center',
                        render: ({ nfi_cfop }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{nfi_cfop}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'UM.',
                        width: '2%',
                        align: 'center',
                        render: ({ nfi_unidademedida }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{nfi_unidademedida}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'Qtde.',
                        width: '3%',
                        align: 'right',
                        render: ({ nfi_qtde }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <Col>
                                        <b>{nfi_qtde}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: (<Tooltip title="Valor Unitário em Reais">Vlr Unit. <small>(R$)</small></Tooltip>),
                        align: 'right',
                        width: '4%',
                        render: ({ nfi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(nfi_valorunitario, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: (
                            <Row justify="space-between" align="middle">
                                <Col>
                                    Acrésc.:
                                </Col>
                                <Col>
                                    <Tooltip title="Valor Acréscimo em Reais">
                                        <small> (R$)</small>
                                    </Tooltip>
                                </Col>
                            </Row>
                        ),
                        align: 'right',
                        width: '3%',
                        render: ({ nfi_valoroutros }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <b>{FormatNumber(nfi_valoroutros, true)}</b>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: (
                            <Row justify="space-between" align="middle">
                                <Col>
                                    Desc.:
                                </Col>
                                <Col>
                                    <Tooltip title="Valor Desconto em Reais">
                                        <small> (R$)</small>
                                    </Tooltip>
                                </Col>
                            </Row>
                        ),
                        align: 'right',
                        width: '3%',
                        render: ({ nfi_valordesconto }) => (
                            <div>
                                <b>{FormatNumber(nfi_valordesconto, true)}</b>
                            </div>
                        )
                    },
                    {
                        title: (
                            <Tooltip title="Percentual Desconto">
                                <small>(%)</small>
                            </Tooltip>
                        ),
                        align: 'right',
                        width: '2%',
                        render: ({ perc_desconto }) => (
                            <div>
                                <b>{FormatNumber(perc_desconto, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'BC Issqn',
                        width: '3%',
                        align: 'right',
                        render: ({ nfs_valorbc }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <Col>
                                        <b>{FormatNumber(nfs_valorbc, true)}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: '% Issqn',
                        width: '3%',
                        align: 'right',
                        render: ({ nfs_percissqn }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <Col>
                                        <b>{FormatNumber(nfs_percissqn, true)}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'Vlr Issqn',
                        width: '3%',
                        align: 'right',
                        render: ({ nfs_valorissqn }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <Col>
                                        <b>{FormatNumber(nfs_valorissqn, true)}</b>
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: (<Tooltip title="Valor Total em Reais">Vlr Total. <small>(R$)</small></Tooltip>
                        ),
                        align: 'right',
                        fixed: 'right',
                        width: '5%',
                        render: ({ nfi_valorunitario, nfi_qtde }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <b>{FormatNumber(nfi_qtde * nfi_valorunitario, true)}</b>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Ações',
                        align: 'center',
                        fixed: 'right',
                        key: 'x',
                        width: '2%',
                        render: (record) => {
                            return (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Dropdown menu={menuTable(record)} trigger={['click']}>
                                                <Button onClick={e => e.preventDefault()} icon={<MoreOutlined />} />
                                            </Dropdown>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                    }
                ]
            } dataSource={itensNF}
                scroll={{
                    x: 1000,
                    y: 300,
                }}
            />
            <ModalDetalheRetencaoNfi exibirModal={exibirModalRetencao} fecharModal={() => setExibirModalRetencao(false)} item={dadosItem} />
        </div>
    )
}